<div class="docs-section" id="authentication">
  <div class="docs-section__head">
    <h1 class="docs-h1">Authentication</h1>
    <p class="docs-subtitle">Every endpoint is a POST with a JSON body, authenticated with an organization API key issued to you from the developer portal.</p>
  </div>

  <div class="docs-code-panel">
    <div class="docs-code-panel__header">
      <div class="docs-code-tabs"><button type="button" class="docs-code-tab docs-code-tab--active">HTTP</button></div>
    </div>
    <pre class="docs-code-pre">POST http://api.mila.test:3000/v1/api/rag
Authorization: Bearer cks_live_&hellip;
Content-Type: application/json</pre>
  </div>

  <p class="docs-subtitle">
    Create a key from <a class="link" routerLink="/api-keys">API Keys</a> it's tied to your organization's
    prepaid wallet balance. See <a class="link" routerLink="/docs/pricing-limits">Pricing &amp; limits</a> for how
    calls draw against it.
  </p>
</div>
